<template>
  <v-app class="simulation-page">
    <v-dialog v-model="showProgress" persistent max-width="320">
      <v-card>
        <v-card-title>Gerando planilha...</v-card-title>
        <v-card-text>
          <v-progress-linear indeterminate color="primary" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showError" max-width="340">
      <v-card>
        <v-card-title>Mensagem</v-card-title>
        <v-card-text>{{ errorMessage }}</v-card-text>
        <v-card-actions class="justify-center">
          <v-btn color="primary" @click="showError = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container>
      <v-row>
        <v-col cols="12">
          <base-material-card color="primary" icon="mdi-flask-outline" inline>
            <template v-slot:after-heading>
              <div class="text-h4 font-weight-light">Simulação de vendas</div>
              <div class="text-caption grey--text">
                Área de testes disponível somente para administradores
              </div>
            </template>

            <filtro-component
              :opcoes="opcoes"
              :produtos="produtos"
              :modos="modos"
              :tipos="tipos"
              :calendar="'mes'"
              :title_opcao="'Campanha'"
              :campos="'N'"
              @filtrar="filterData"
              @showError="showSelectionError"
            />
          </base-material-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" lg="3">
          <base-material-stats-card
            color="rgb(71 130 180)"
            icon="mdi-cash"
            title="Valor distribuído"
            :valuex="false"
            :value="formatCurrency(totalDistribuido)"
          />
        </v-col>
        <v-col cols="12" sm="6" lg="3">
          <base-material-stats-card
            color="green"
            icon="mdi-percent"
            title="Comissão simulada"
            :valuex="false"
            :value="formatCurrency(totalComissao)"
          />
        </v-col>
        <v-col cols="12" sm="6" lg="3">
          <base-material-stats-card
            color="purple"
            icon="mdi-cash-plus"
            title="Adicional de mensalidades"
            :valuex="false"
            :value="formatCurrency(totalAdicional)"
          />
        </v-col>
        <v-col cols="12" sm="6" lg="3">
          <base-material-stats-card
            color="orange"
            icon="mdi-account-group"
            title="Vendedores"
            :valuex="false"
            :value="String(listaAgrupada.length)"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <base-material-card color="primary" icon="mdi-table" inline>
            <template v-slot:after-heading>
              <div class="text-h4 font-weight-light">Resultado da simulação</div>
            </template>

            <v-data-table
              :headers="headers"
              :items="listaAgrupada"
              :loading="isLoading"
              :items-per-page="15"
              loading-text="Consultando vendas..."
              no-data-text="Nenhuma simulação consultada"
              class="elevation-0"
            >
              <template v-slot:item.valorVenda="{ item }">
                {{ formatCurrency(item.valorVenda) }}
              </template>
              <template v-slot:item.comissao="{ item }">
                {{ formatCurrency(item.comissao) }}
              </template>
              <template v-slot:item.adicional="{ item }">
                {{ formatCurrency(item.adicional) }}
              </template>
              <template v-slot:item.empresa="{ item }">
                <v-chip small color="primary" text-color="white">
                  {{ item.empresa }}
                </v-chip>
              </template>
            </v-data-table>

            <v-card-actions class="justify-end px-0">
              <v-btn
                color="success"
                :disabled="!lista.length || isLoading"
                @click="downloadXls"
              >
                <v-icon left>mdi-file-excel</v-icon>
                Baixar planilha
              </v-btn>
            </v-card-actions>
          </base-material-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import FiltroComponent from "./components/FiltroGeral.vue";
import Comissao from "../../services/comissao";

export default {
  name: "SimulacaoVenda",

  components: {
    FiltroComponent,
  },

  data() {
    return {
      headers: [
        { text: "Vendedor", value: "vendedor" },
        { text: "Cargo", value: "profissao" },
        { text: "Supervisor", value: "supervisor" },
        { text: "Empresa", value: "empresa" },
        { text: "Valor da venda", value: "valorVenda" },
        { text: "Adicional", value: "adicional" },
        { text: "Comissão", value: "comissao" },
        { text: "Quantidade", value: "qtd_venda" },
      ],
      lista: [],
      listaAgrupada: [],
      totalDistribuido: 0,
      totalComissao: 0,
      totalAdicional: 0,
      isLoading: false,
      showProgress: false,
      showError: false,
      errorMessage: "Por favor, selecione pelo menos uma empresa.",
      selectedStartDate: "",
      selectedEndDate: "",
      selectedCompany: "",
      selectedType: "Todos",
      selectedOpcao: "Todas",
      produto: "Todos",
      opcoes: ["Todas", "Campanha 50 Anos"],
      produtos: ["Todos"],
      modos: ["Período"],
      tipos: ["Todos"],
    };
  },

  methods: {
    async filterData(valores) {
      this.selectedStartDate = valores.selectedStartDate;
      this.selectedEndDate = valores.selectedEndDate;
      this.selectedCompany = Array.isArray(valores.selectedCompany)
        ? valores.selectedCompany.join(",")
        : valores.selectedCompany;
      this.selectedType =
        valores.selectedType === "Jazigo" ? "Cemitérios" : valores.selectedType;
      this.selectedOpcao = valores.selectedOpcao;
      this.produto = valores.selectedProduto;

      if (!this.selectedCompany) {
        this.showSelectionError();
        return;
      }

      if (!this.periodoValido(365)) return;

      this.isLoading = true;
      try {
        const response = await Comissao.lista_simulacao_venda(
          this.toIso(this.selectedStartDate),
          this.toIso(this.selectedEndDate),
          this.selectedCompany,
          this.selectedType,
          "Todos",
          this.selectedOpcao,
          this.produto
        );
        this.lista = response.data || [];
        this.agruparPorVendedor();
      } catch (error) {
        this.lista = [];
        this.agruparPorVendedor();
        this.showRequestError(error, "Não foi possível gerar a simulação.");
      } finally {
        this.isLoading = false;
      }
    },

    async downloadXls() {
      if (!this.periodoValido(90)) return;

      this.showProgress = true;
      try {
        const response = await Comissao.planilha_simulacao_venda(
          this.toIso(this.selectedStartDate),
          this.toIso(this.selectedEndDate),
          this.selectedCompany,
          this.selectedType,
          "Todos",
          this.selectedOpcao,
          this.produto
        );
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.download = `simulacao_vendas_${this.competenciaArquivo()}_${Date.now()}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        this.showRequestError(error, "Não foi possível baixar a planilha.");
      } finally {
        this.showProgress = false;
      }
    },

    agruparPorVendedor() {
      const agrupado = {};
      this.totalDistribuido = 0;
      this.totalComissao = 0;
      this.totalAdicional = 0;

      this.lista.forEach((item) => {
        if (!item.id_vendedor) return;
        if (!agrupado[item.id_vendedor]) {
          agrupado[item.id_vendedor] = {
            vendedor: item.vendedor,
            profissao: item.profissao,
            supervisor: item.supervisor,
            empresa: item.empresa,
            valorVenda: 0,
            adicional: 0,
            comissao: 0,
            qtd_venda: item.qtd_venda || 0,
          };
        }
        const valorVenda = Number(item.valorVenda || 0);
        const comissao = Number(item.comissao || 0);
        const adicional = Number(item.adicional || 0);
        agrupado[item.id_vendedor].valorVenda += valorVenda;
        agrupado[item.id_vendedor].adicional += adicional;
        agrupado[item.id_vendedor].comissao += comissao;
        this.totalDistribuido += valorVenda;
        this.totalComissao += comissao;
        this.totalAdicional += adicional;
      });

      this.listaAgrupada = Object.values(agrupado);
    },

    periodoValido(limite) {
      const inicio = new Date(this.toIso(this.selectedStartDate));
      const fim = new Date(this.toIso(this.selectedEndDate));
      const dias = (fim - inicio) / 86400000;
      if (!Number.isFinite(dias) || dias < 0 || dias > limite) {
        this.errorMessage = `O período deve ser válido e não pode superar ${limite} dias.`;
        this.showError = true;
        return false;
      }
      return true;
    },

    toIso(data) {
      if (!data) return "";
      const partes = data.split("/");
      return partes.length === 3 ? `${partes[2]}-${partes[1]}-${partes[0]}` : data;
    },

    competenciaArquivo() {
      const partes = this.selectedStartDate.split("/");
      return partes.length === 3
        ? `${partes[1]}_${partes[2]}`
        : "periodo_selecionado";
    },

    formatCurrency(valor) {
      return Number(valor || 0).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },

    showSelectionError() {
      this.errorMessage = "Por favor, selecione pelo menos uma empresa.";
      this.showError = true;
    },

    showRequestError(error, fallback) {
      const message = error && error.response && error.response.data;
      this.errorMessage = typeof message === "string" ? message : fallback;
      this.showError = true;
    },
  },
};
</script>

<style scoped>
.simulation-page {
  background-color: #f8f9fb !important;
}
</style>
